export default __webpack_public_path__ + "static/media/pendientes.f7e543bd.svg";